<div class="submit-error-box">
  <div class="submit-error-header">
    Alert Message
  </div>

  <div class="eca-no-data-centered">
    <div>
      An error occurred during the submission to scoring. Please clear the alert and submit again at a later time.
    </div>
    <img src="assets/nothing-to-display-no-text.png">
  </div>
</div>
